import { getCurrentCulture } from "@utils";
import { MyDepositsBody } from "@features/payment/deposit/desktop/my-deposits";
import { NewDepositBody } from "@features/payment/deposit/desktop/new-deposit";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";

export default function DepositTabs() {
	return (
		<Switch>
			<Route exact path={["/:culture/deposit"]}>
				<NewDepositBody />
			</Route>

			<Route exact path={["/:culture/deposit/history"]}>
				<MyDepositsBody />
			</Route>

			<Redirect to={`/${getCurrentCulture()}/${DefaultPath.HOME}`} />
		</Switch>
	);
}
